import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function SubpageHero({ eyebrow, title, subtitle, withCta }) {
  return (
    <section className="bg-[#0A1128] pt-28 pb-16">
      <div className="container-eos">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.18em] uppercase text-slate-400 hover:text-[#F26522] transition-colors mb-8"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Volver al inicio
        </Link>

        <p className="text-[11px] font-bold tracking-[0.28em] uppercase text-[#F26522]">
          {eyebrow}
        </p>

        <h1 className="mt-4 font-display font-extrabold text-white leading-[1.05] tracking-[-0.02em] text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-5 text-slate-300 text-base sm:text-lg max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}

        {withCta && (
          <Link
            to="/contacto"
            data-testid="subpage-hero-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#F26522] text-white font-bold uppercase tracking-[0.08em] text-sm px-6 py-3.5 rounded-md shadow-lg shadow-[#F26522]/20 hover:bg-[#D95214] hover:-translate-y-0.5 transition-all"
          >
            Coordinemos una llamada
            <ArrowRight className="w-4 h-4" />
          </Link>
        )}
      </div>
    </section>
  );
}
